var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"icp"},[_c('span',[_vm._v("证券投资基金业协会注册号：P1071492")]),_c('img',{staticClass:"police",attrs:{"src":require("@/assets/police.png"),"alt":""}}),_c('span',[_vm._v("备案/许可证号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("沪ICP备2021016981号")])])])])
}]

export { render, staticRenderFns }